/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2024-01-10 21:28:16
 */

import React, { useRef, useState } from 'react'
import { Checkbox, Popover } from 'antd'
import sensors from '../../utils/sensors'

const UseHistory = () => {
  const ref = useRef<HTMLDivElement>(null)
  const [isUseHistory, setIsUseHistory] = useState(
    JSON.parse(localStorage.getItem('jigsaw_isUseHistory') || 'false')
  )
  // const [popupVisible, setPopupVisible] = useState(
  //   !JSON.parse(localStorage.getItem('jigsaw_isUseHistory_popuped'))
  // )

  const onChange = (e: { target: { checked: boolean } }) => {
    setIsUseHistory(e.target.checked)
    localStorage.setItem('jigsaw_isUseHistory', String(e.target.checked))
    sensors.track('web_workgroup_jigsaw_click', {
      clickItem: 'use_history',
      open: e.target.checked
    })
  }

  // const Content = () => {
  //   return (
  //     <div style={{ position: 'relative', paddingRight: 40 }}>
  //       新增「历史记录」功能
  //       <br />
  //       开启后可自动填入上次拼图内容{' '}
  //       <Icon
  //         style={{ position: 'absolute', top: 0, right: 0 }}
  //         type="close-circle"
  //         onClick={() => {
  //           setPopupVisible(false)
  //           localStorage.setItem('jigsaw_isUseHistory_popuped', 'true')
  //           sensors.track('web_workgroup_jigsaw_click', {
  //             clickItem: 'use_history_popup_close'
  //           })
  //         }}
  //       />
  //     </div>
  //   )
  // }

  return (
    <div ref={ref}>
      {/* <Popover
        content={<Content />}
        visible={popupVisible}
        classNames={{ root: 'jigsaw-history-popover' }}
      > */}
      <Checkbox
        checked={isUseHistory}
        onChange={onChange}
        style={{ fontWeight: 'bold' }}
      >
        启用历史记录（保存拼图后生效）
      </Checkbox>
      {/* </Popover> */}
    </div>
  )
}

export default UseHistory
